export const FOOTER_COPYRIGHT = '\u00A9 2026 Fiverr International LTD.';
export const FOOTER_PRIVACY_TEXT = 'Privacy';
export const FOOTER_PRIVACY_URL = 'https://www.fiverr.com/legal-portal/privacy/privacy-policy';
export const FOOTER_TERMS_TEXT = 'Terms of Service';
export const FOOTER_TERMS_URL = 'https://www.fiverr.com/legal-portal/legal-terms/terms-of-service';
